export default __webpack_public_path__ + "static/media/Payment.f4dfef4c.svg";